<template>
  <div class="md-layout md-alignment-top-left extra-option">
    <div class="md-layout-item md-size-40">
      <md-field class="" slot="inputs">
        <label>Title</label>
        <md-input v-model="option.title" type="text"></md-input>
      </md-field>

      <md-field class="option-select">
        <label>Option Type</label>
        <md-select
          v-model="option.type"
          md-dense
          placeholder="Choose the input type"
        >
          <md-option
            v-for="inputType in inputTypes"
            :key="inputType.title"
            :value="inputType.value"
            >{{ inputType.title }}</md-option
          >
        </md-select>
      </md-field>

      <md-switch v-model="option.required">Mark as <i>Required</i></md-switch>
    </div>
    <div class="md-layout-item md-size-50">
      <md-field class="" slot="inputs">
        <label>Values</label>
        <md-input v-model="option.values" type="text"></md-input>
      </md-field>
      <md-field class="" slot="inputs">
        <label>Default Value</label>
        <md-input v-model="option.default_value" type="text"></md-input>
      </md-field>
    </div>

    <!-- <div>
        <span class="md-caption">Option Values</span><br />
        {{ option.values }}
      </div>
      <div>
        <span class="md-caption">Default Value</span><br />
        {{ option.default_value }}
      </div>
    </div> -->
    <div class="md-layout-item md-size-10 text-right">
      <div>
        <md-button
          class="md-just-icon md-simple md-danger "
          @click="deleteOption({ option, index })"
        >
          <md-icon>delete</md-icon>
          <md-tooltip md-direction="top">Delete</md-tooltip>
        </md-button>
      </div>
    </div>
  </div>
</template>
<script>
import confirm from "@/helpers/deleteConfirm";

export default {
  name: "ExtraOption",

  props: ["option", "index"],

  data() {
    return {
      inputTypes: [
        { title: "Dropdown", value: "select" },
        // { title: "Radio", value: "radio" },
        { title: "Switch", value: "checkbox" },
        { title: "Text", value: "text" }
      ]
    };
  },

  methods: {
    deleteOption(args) {
      confirm.delete().then(resp => {
        if (resp.value) {
          this.$emit("deleteOption", args);
        }
      });
    }
  },

  watch: {
    // option: {
    //   handler(val){
    //     console.log("VALUE", val);
    //   },
    //   deep: true
    // }
  },

  computed: {},

  mounted() {}
};
</script>
<style lang="scss" scoped>
.extra-option {
  h5 {
    margin: 0;
  }
  border-bottom: 1px solid #00bcd4;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
}
</style>
